module.exports = __webpack_public_path__ + "img/BeachDJNoTasksLeft.550cab6d.png";